module.exports = __webpack_public_path__ + "media/images/icon/i-matching-349aab449e4915fd26c80ec9d792c076.svg";